import React, { useCallback, useState, useEffect, Dispatch, useRef, MouseEvent } from 'react'
import { useDropzone } from 'react-dropzone'
import { DebouncedFunc } from 'lodash'
import { checkMagicBytes } from '../helpers/helperFunctions';
import { getUploadUrl as getUploadUrl1, uploadImageFile as uploadImageFile1, fetchImages as fetchImages1, fetchInjects, deleteImage as deleteImage1 } from '../features/injectSlice'
import { getUploadUrl as getUploadUrl2, uploadImageFile as uploadImageFile2, fetchImages as fetchImages2, deleteImage as deleteImage2 } from '../features/scenarioSlice'
import { getSnippetsUploadUrl, uploadSnippetsImageFile, fetchSnippetsImages, deleteSnippetsImage } from '../features/scenarioSlice'
import { fetchScenarios } from '../features/scenarioSlice'
import { useAppDispatch } from '../app/hooks'
import { IScenario, IInject, ITurnBrief } from '../interfaces';
import { Inject } from '../Classes1';
import ImageCrop from './ImageCrop/ImageCrop';
import Modal from 'react-modal';
import 'react-image-crop/dist/ReactCrop.css'
import _ from 'lodash';

interface DropzoneProps {
    injectId?: string;
    image?: string;
    images?: string[];
    localImage?: string;
    selectedScenario: IScenario;
    saveScenario: (i: IInject[]) => Promise<void>;
    injectComponents?: IInject[];
    setInjectComponents?: Dispatch<any>;
    injectItem?: IInject;
    setInjectItem?: Dispatch<any>;
    setSelectedScenario: Dispatch<any>;
    createInjectComponents?: Dispatch<any>;
    type: string;
    turn?: number;
    onError: Dispatch<string>;
    onChangeSave: DebouncedFunc<any>;
    disabled?: boolean;
    setNewSnippet?: Dispatch<ITurnBrief>;
    newSnippet?: ITurnBrief;
  }

  const defaultProps = {
    injectId: '1',
    injectComponents: [],
    localImage: '',
    setInjectComponents: () => {},
    injectItem: new Inject({}),
    setInjectItem: new Inject({}),
    createInjectComponents: () => {},
    type: '',
    turn: 1
  };

  const customStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '900px',
      transform: 'translate(-50%, -50%)'
    }
  };

  const MAX_IMAGES = 10;
  const MAX_IMAGE_SIZE = process.env.REACT_APP_IMAGE_SRC === 'cloud' ? 4000000 : 500000;
  const MAX_IMAGE_SIZE_LABEL = MAX_IMAGE_SIZE / 1000

  function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
  }

  Modal.setAppElement('#root');

const Dropzone: React.FC<DropzoneProps> = (propsIn: DropzoneProps) => {
  const props = {...defaultProps, ...propsIn};

  const dispatch: any = useAppDispatch();
  
  const [imageUrls, setImageUrls] = useState<any>({})
  const [snippetsImageUrls, setSnippetsImageUrls] = useState<any[]>([])
  const [scenarioImageUrls, setScenarioImageUrls] = useState<any[]>([])
  const [imageLoading, setImageLoading] = useState<boolean>(false)
  const [showCurrentImage, setShowCurrentImage] = useState<string>('')
  const [cropModalIsOpen, setCropModalIsOpen] = useState<boolean>(false);
  const [fileToCrop, setFileToCrop] = useState<any>();
  const [fileNameToCrop, setFileNameToCrop] = useState<any>();
  const [croppedImage, setCroppedImage] = useState<any>();
  const [base64img, setBase64img] = useState<string>('')
  const [deleteImgLoading, setDeleteImgLoading] = useState<boolean>(false)

  let getUploadUrl: any;
  let uploadImageFile: any;
  let fetchImages: any;
  let deleteImage: any;

  switch(props.type) {
    case 'inject':
        getUploadUrl = getUploadUrl1
        uploadImageFile = uploadImageFile1
        fetchImages = fetchImages1
        deleteImage = deleteImage1
        break;
    case 'scenario':
        getUploadUrl = getUploadUrl2
        uploadImageFile = uploadImageFile2
        fetchImages = fetchImages2
        deleteImage = deleteImage2
        break;
    case 'snippets':
        getUploadUrl = getSnippetsUploadUrl
        uploadImageFile = uploadSnippetsImageFile
        fetchImages = fetchSnippetsImages
        deleteImage = deleteSnippetsImage
        break;
    default:
        break;
  }

  useEffect(() => {
    if (props.type === 'scenario') {
      if (_.isEmpty(props.selectedScenario.id)) {
        return;
      }

      dispatch(
        fetchImages(props.selectedScenario.id)
      ).then((imgResp: any) => {
        setScenarioImageUrls(imgResp.payload);
      })
    }
  }, [props.selectedScenario.id, props.selectedScenario.images]) // eslint-disable-line react-hooks/exhaustive-deps

  const openCropModal = () => {
    setCropModalIsOpen(true);
  }

  const closeCropModal = (evt:any) => {
    if (evt.cancelCrop) {
      setImageLoading(false);
      setImageUrls({});
      setScenarioImageUrls([]);
      setShowCurrentImage('');
    }
    setCropModalIsOpen(false);
  }

  useEffect(() => {
    async function uploadImage() {
      setImageLoading(true);

      if (props.saveScenario) await props.saveScenario([])

      let getImageUrl = await dispatch(getUploadUrl({injectId: props.injectId, fileName: fileNameToCrop}))
      
      await dispatch(uploadImageFile({imageFile: croppedImage, gcsUrl: getImageUrl.payload.url}))
      
      let gotImages = await dispatch(fetchImages(props.injectId))
      setImageUrls(gotImages.payload)
      updateInjectImages()

      setImageLoading(false)
    }

    if (croppedImage !== undefined) {
      uploadImage()
    }
    
  }, [croppedImage]); // eslint-disable-line react-hooks/exhaustive-deps

  const scenarioRef = useRef<any>()
  useEffect(() => {
    scenarioRef.current = props.selectedScenario
  });

  const injectComponentsRef = useRef<any>()
  useEffect(() => {
    injectComponentsRef.current = props.injectComponents
  });

  async function updateInjectImages() {
    let scenarios = await dispatch(fetchScenarios())
      for (let i = 0; i<scenarios.payload.myScenarios.length; i++) {
          if (scenarios.payload.myScenarios[i].id === props.selectedScenario.id) {
            let newInjects: any = await dispatch(fetchInjects(props.selectedScenario.id))
            props.setInjectComponents(await props.createInjectComponents(newInjects?.payload.injects));
            props.setSelectedScenario(scenarios.payload.myScenarios[i]);
          }
      }
  }

  useEffect(() => {
    async function getImagesAsync() {
        let gotImages: any
        if (props.type === 'inject' && !_.isEmpty(props.injectId) && props.image !== '') {
            gotImages = await dispatch(fetchImages(props.injectId))
            setImageUrls(gotImages.payload)
        } else if (props.type === 'scenario' && !_.isEmpty(props.selectedScenario.id) ) {
            gotImages = await dispatch(fetchImages(props.selectedScenario.id))
            setScenarioImageUrls(gotImages.payload)
        } else if (props.type === 'snippets') {
            gotImages = await dispatch(fetchImages({ scenarioId: props.selectedScenario.id, turn: props.turn }))
            setSnippetsImageUrls(gotImages.payload)
        }
    }
    getImagesAsync();
  }, [props.injectId, dispatch, props.image]) // eslint-disable-line react-hooks/exhaustive-deps

  // Scenario onDrop
  const onScenarioDrop = useCallback( async(files: File[]) => {
    const currentImgCount = scenarioRef.current.images.length;
    const allowImgCount = MAX_IMAGES - currentImgCount;
    const validFilesChecks = files.filter((f) => f.size <= MAX_IMAGE_SIZE).map((file) => checkMagicBytes(file).then((valid) => valid ? file : null));
    const validFilesResult = await Promise.all(validFilesChecks)
    const validFiles = validFilesResult.filter(notEmpty); // Have to use this function because we are < TS5.5
    if (validFiles.length === 0) {
      props.onError!(`Files must be png or jpg image files smaller than ${MAX_IMAGE_SIZE_LABEL}kb in size.`);
      return;
    }

    if (validFiles.length < files.length) {
      props.onError!(`Ignoring invalid files that are not png or jpg files smaller than ${MAX_IMAGE_SIZE_LABEL}kb in size.`);
    }

    if (validFiles.length > allowImgCount) {
      props.onError!(`You selected more than ${allowImgCount} files. Only accepting the first ${allowImgCount} valid files.`);
    }

    if (process.env.REACT_APP_IMAGE_SRC === 'cloud') {
      // Gotta do these one at a time for now.
      for (const file of validFiles.slice(0, allowImgCount)) {
        const imgUrlResp = await dispatch(getUploadUrl({scenarioId: props.selectedScenario.id, fileName: file.name}))
        // Upload directly to that url.
        const uploadUrl = imgUrlResp.payload.url;
        await dispatch(uploadImageFile({imageFile: file, gcsUrl: uploadUrl}))
      }

      const updatedImgResp: any = await dispatch(fetchImages(props.selectedScenario.id));
      const updatesImgs = updatedImgResp.payload;
      const updatedImgNames = updatesImgs.map((img: any) => img.fileName);
      props.setSelectedScenario({
        ...scenarioRef.current, 
        images: updatedImgNames
      });
      setImageUrls(updatesImgs)

      props.onChangeSave();
      setTimeout(() => {
        setBase64img('');
      }, 3000)
    } else {
      let reader: any = new FileReader();
      reader.onload = function () {
          const base64String = reader.result.split(',')[1];
          setBase64img(reader.result);
          // When first fetced, localImages is a count and not an array...
          const localImages = Array.isArray(scenarioRef.current.localImages)
            ? scenarioRef.current.localImages
            :imageUrls
              .map(({ url }:{url:string}) => url)
              .filter(({url}:{url:string}) => url.match(/^data:/))
              .map(({url}:{url:string}) => url.split(',')[1])
          localImages.push(base64String);
          props.setSelectedScenario({
            ...scenarioRef.current,
            localImages,
          });
          props.onChangeSave();
          setTimeout(() => {
            setBase64img('');
          }, 3000)
      }
      reader.readAsDataURL(files[0]);
    }

  }, [dispatch, props.selectedScenario, scenarioRef]); // eslint-disable-line react-hooks/exhaustive-deps

  // Scenario onDrop
  const onSnippetsDrop = useCallback( async(files: File[]) => {
    const currentImgCount = props.newSnippet!.images.length;
    const allowImgCount = MAX_IMAGES - currentImgCount;
    const validFilesChecks = files.filter((f) => f.size <= MAX_IMAGE_SIZE).map((file) => checkMagicBytes(file).then((valid) => valid ? file : null));
    const validFilesResult = await Promise.all(validFilesChecks)
    const validFiles = validFilesResult.filter(notEmpty); // Have to use this function because we are < TS5.5
    if (validFiles.length === 0) {
      props.onError!(`Files must be png or jpg image files smaller than ${MAX_IMAGE_SIZE_LABEL}kb in size.`);
      return;
    }

    if (validFiles.length < files.length) {
      props.onError!(`Ignoring invalid files that are not png or jpg files smaller than ${MAX_IMAGE_SIZE_LABEL}kb in size.`);
    }

    if (validFiles.length > allowImgCount) {
      props.onError!(`You selected more than ${allowImgCount} files. Only accepting the first ${allowImgCount} valid files.`);
    }

    if (process.env.REACT_APP_IMAGE_SRC === 'cloud') {
      // Gotta do these one at a time for now.
      for (const file of validFiles.slice(0, allowImgCount)) {
        //scenarioId, turn, fileName
        const imgUrlResp = await dispatch(getUploadUrl({scenarioId: props.selectedScenario.id, turn: props.turn, fileName: file.name}))
        // Upload directly to that url.
        const uploadUrl = imgUrlResp.payload.url;
        await dispatch(uploadImageFile({imageFile: file, gcsUrl: uploadUrl}))
      }

      const updatedImgResp: any = await dispatch(fetchImages({ scenarioId: props.selectedScenario.id, turn: props.turn }));
      const updatesImgs = updatedImgResp.payload;
      const updatedImgNames = updatesImgs.map((img: any) => img.fileName);

      if (props.setNewSnippet) {
        if (props.newSnippet) {
          props.setNewSnippet({
            briefingText: props.newSnippet.briefingText,
            turn: props.newSnippet.turn,
            images: updatedImgNames
          });
        }
      }

      let snippetsArray: ITurnBrief[] = JSON.parse(JSON.stringify(props.selectedScenario.snippets))
      snippetsArray.forEach((snippet: ITurnBrief) => {
        if (snippet.turn === props.turn) {
          snippet.images = updatedImgNames
        }
      })

      props.setSelectedScenario({
        ...scenarioRef.current, 
        snippets: snippetsArray
      });
      setSnippetsImageUrls(updatesImgs)

      props.onChangeSave();
      setTimeout(() => {
        setBase64img('');
      }, 3000)
    } else {
      let reader: any = new FileReader();
      reader.onload = function () {
          const base64String = reader.result.split(',')[1];
          setBase64img(reader.result);
          // When first fetced, localImages is a count and not an array...
          const localImages = Array.isArray(scenarioRef.current.localImages)
            ? scenarioRef.current.localImages
            :imageUrls
              .map(({ url }:{url:string}) => url)
              .filter(({url}:{url:string}) => url.match(/^data:/))
              .map(({url}:{url:string}) => url.split(',')[1])
          localImages.push(base64String);
          props.setSelectedScenario({
            ...scenarioRef.current,
            localImages,
          });
          props.onChangeSave();
          setTimeout(() => {
            setBase64img('');
          }, 3000)
      }
      reader.readAsDataURL(files[0]);
    }

  }, [dispatch, props.newSnippet]); // eslint-disable-line react-hooks/exhaustive-deps

  const onInjectDrop = useCallback( async(acceptedFiles: File[]) => {

    const validFilesChecks = acceptedFiles.filter((f) => f.size <= MAX_IMAGE_SIZE).map((file) => checkMagicBytes(file).then((valid) => valid ? file : null));
    const validFilesResult = await Promise.all(validFilesChecks)
    const validFiles = validFilesResult.filter(notEmpty); // Have to use this function because we are < TS5.5
    if (validFiles.length === 0) {
      props.onError!(`Files must be png or jpg image files smaller than ${MAX_IMAGE_SIZE_LABEL}kb in size.`);
      return;
    }
    
    setImageLoading(true)
    setFileToCrop(acceptedFiles[0])
    setFileNameToCrop(acceptedFiles[0].name)
    openCropModal()
    
  }, [props.injectId, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  let onDrop;
  switch(props.type) {
    case 'inject':
        onDrop = onInjectDrop
        break;
    case 'scenario':
        onDrop = onScenarioDrop
        break;
    case 'snippets':
        onDrop = onSnippetsDrop
        break;
    default:
        break;
  }
  
  const { getRootProps, getInputProps, isDragActive } = useDropzone({onDrop})

  const deleteImg = async (ev: MouseEvent) => {

    if (imageLoading) {
      return;
    }
    setImageLoading(true)

    let deleteImgResp: any
    if (props.type === 'inject') {
        deleteImgResp = await dispatch(deleteImage({injectId: props.injectId, fileName: props.image}))
    } else if (props.type === 'scenario') {
        deleteImgResp = await dispatch(deleteImage({injectId: props.injectId, fileName: props.image}))
    } else if (props.type === 'snippets') {
        deleteImgResp = await dispatch(deleteImage({injectId: props.injectId, fileName: props.image}))
    }
    
    if (deleteImgResp) {
      setImageUrls({})
      setShowCurrentImage('')
      setImageLoading(false)
    }
  }

  const removeFeatureImage = async (ev: React.MouseEvent<HTMLElement>) => {
    if (deleteImgLoading) {
      return;
    }
    
    setDeleteImgLoading(true)

    if (ev.currentTarget instanceof HTMLElement) {
        
      await dispatch(
        deleteImage({scenarioId: props.selectedScenario.id, fileName: ev.currentTarget.dataset.filename!}))

      setDeleteImgLoading(false)
      let gotImages: any = await dispatch(fetchImages(props.selectedScenario.id))
      setImageUrls(gotImages.payload)
      
      let scenarios = await dispatch(fetchScenarios())
      let scenario: any = {};
      for (let i = 0; i<scenarios.payload.myScenarios.length; i++) {
        if (scenarios.payload.myScenarios[i].id === props.selectedScenario.id) {
          scenario = JSON.parse(JSON.stringify(scenarios.payload.myScenarios[i]))
        }
      }

      const imgArr : string[] = gotImages.payload.map((img : any) => img.fileName);
      props.setSelectedScenario({
        ...scenario, 
        images: imgArr.filter((img) => !(/^txplocal~\d+:/.test(img)))
      });
    }
  }

  const removeSnippetImage = async (ev: React.MouseEvent<HTMLElement>) => {
    if (deleteImgLoading) {
      return;
    }
    
    setDeleteImgLoading(true)

    if (ev.currentTarget instanceof HTMLElement) {
        
      await dispatch(deleteSnippetsImage({scenarioId: props.selectedScenario.id, turn: props.turn, fileName: ev.currentTarget.dataset.filename!}))

      setDeleteImgLoading(false)
      let gotImages: any = await dispatch(fetchSnippetsImages({scenarioId: props.selectedScenario.id, turn: props.turn}))
      
      setSnippetsImageUrls(gotImages.payload)

      const imgArr : string[] = gotImages.payload.map((img : any) => img.fileName);
      if (props.setNewSnippet) {
        if (props.newSnippet) {
          props.setNewSnippet({
            briefingText: props.newSnippet.briefingText,
            turn: props.newSnippet.turn,
            images: imgArr
          });
        }
      }
    }
  }

  return (
    <div>
    { (props.type === 'inject') ? 
    <div className="inject-image-drop">
      <div className="dropzone-wrapper" {...getRootProps()}>
          <input {...getInputProps()} />
          {
              isDragActive ?
              <div className="drag-section-message">Drop the files here ...</div> :
              <div className="drag-section-message">
                <img className="drag-section-message-image" src="/img/upload-cloud.svg" alt="upload"></img>
                <div className="drag-section-message-text">Drag and drop an image to upload,
              or click to select an image from your computer.</div>
                </div>
          }
      </div>

      {!_.isEmpty(imageUrls) ? <div className="feature-image-files">
          <div className={`inject-image-file ${showCurrentImage}`}>
              <img
                src={imageUrls.url}
                className="feature-img-preview"
                alt=""
              />
              
            </div>
            <div className="inject-image-row">
                  <span className="feature-image-key">{imageUrls.fileName}</span>
                  <div className="feature-image-delete" onClick={deleteImg}>
                    <img src="/img/trash-can.svg" className="feature-image-trashcan" alt="trash" />
                  </div>
            </div>
          </div> : imageLoading ? <div className="feature-image-files">
            <div className="inject-image-file">
              <div className="loader inject-image-loader"></div>
            </div>
          </div> : !_.isEmpty(props.localImage) ? <img src={`${'data:image/png;base64, ' + props.localImage}`} className="base64-preview" alt="img" /> : '' }
    </div> : <></> }

    { props.type === 'scenario' ? <div className="feature-image-drop" style={{opacity: props.disabled ? 0.8 : 1.0}}>
        <div className="dropzone-wrapper" {...getRootProps()}>
            <input {...getInputProps()} />
            {
                isDragActive ?
                <div className="drag-section-message">Drop the files here ...</div> :
                <div className="drag-section-message">
                  <img className="drag-section-message-image" src="/img/upload-cloud.svg" alt="upload"></img>
                  <div className="drag-section-message-text">Drag and drop an image to upload,
                or click to select an image from your computer.</div>
                </div>
            }
        </div>
        <div className="scenario-image-files">
            {
              !_.isEmpty(base64img) &&
              <div className="scenario-image-file">
                <img src={`${base64img}`} className="scenario-img-preview" alt="img" />
                <span className="feature-image-key">Recent Upload</span><img src="img/loading-gif.gif" width="12" className="feature-image-close" alt="" />
              </div>
            }
            {
              !_.isEmpty(base64img) && imageUrls.length > 0 &&
              <hr style={{width: '100%', margin: '1rem 0'}}/>
            }
            {scenarioImageUrls.map((imgObj: any, i: number) => {
                return (<div className="scenario-image-file" key={imgObj.fileName}>
                  <img
                    src={imgObj.url}
                    className="scenario-img-preview"
                    alt=""
                  />
                  <span className="feature-image-key">{imgObj.fileName.replace(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/, '')}</span><img src="img/white-x.svg" className="feature-image-close" onClick={removeFeatureImage} data-filename={imgObj.fileName} alt="" /></div>)
            })}
        </div>
    </div> : <></> }

    { props.type === 'snippets' ? <div className="feature-image-drop" style={{opacity: props.disabled ? 0.8 : 1.0}}>
        <div className="dropzone-wrapper" {...getRootProps()}>
            <input {...getInputProps()} />
            {
                isDragActive ?
                <div className="drag-section-message">Drop the files here ...</div> :
                <div className="drag-section-message">
                  <img className="drag-section-message-image" src="/img/upload-cloud.svg" alt="upload"></img>
                  <div className="drag-section-message-text">Drag and drop an image to upload,
                or click to select an image from your computer.</div>
                </div>
            }
        </div>
        <div className="snippets-image-files">
            {
              !_.isEmpty(base64img) &&
              <div className="snippets-image-file">
                <img src={`${base64img}`} className="scenario-img-preview" alt="img" />
                <span className="feature-image-key">Recent Upload</span><img src="img/loading-gif.gif" width="12" className="feature-image-close" alt="" />
              </div>
            }
            {
              !_.isEmpty(base64img) && imageUrls.length > 0 &&
              <hr style={{width: '100%', margin: '1rem 0'}}/>
            }
            {snippetsImageUrls.map((imgObj: any, i: number) => {
                return (<div className="snippets-image-file" key={imgObj.fileName}>
                  <img
                    src={imgObj.url}
                    className="scenario-img-preview"
                    alt=""
                  />
                  <span className="feature-image-key">{imgObj.fileName.replace(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/, '')}</span><img src="img/white-x.svg" className="feature-image-close" onClick={removeSnippetImage} data-filename={imgObj.fileName} alt="" /></div>)
            })}
        </div>
    </div> : <></> }

      <Modal
          shouldCloseOnOverlayClick={false}
          isOpen={cropModalIsOpen}
          onRequestClose={closeCropModal}
          style={customStyles}
          contentLabel="Crop Image Modal"
      >
        <div className="image-crop-wrapper">
          <ImageCrop fileToCrop={fileToCrop} setCroppedImage={setCroppedImage} closeCropModal={closeCropModal} />
        </div>
      </Modal>
    </div>
  )
}

export default Dropzone;